
// These imports work because we are using @rollup/plugin-url.
// See package.json and rollup.config.js

import connectorUrl from './connector.vef'
import maroonUrl from './maroon.vef'
import blueUrl from './blue.vef'
import yellowUrl from './yellow.vef'
import purpleUrl from './purple.vef'
import redUrl from './red.vef'
import brownUrl from './brown.vef'
import greenUrl from './green.vef'
import oliveUrl from './olive.vef'
import lavenderUrl from './lavender.vef'

const shapes = {
  connector: connectorUrl,
  maroon: maroonUrl,
  blue: blueUrl,
  yellow: yellowUrl,
  purple: purpleUrl,
  red: redUrl,
  brown: brownUrl,
  green: greenUrl,
  olive: oliveUrl,
  lavender: lavenderUrl,
}

export default shapes